import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { FastField } from 'formik';
import _ from 'lodash';
import { InputFormField } from '@playbookux/playbook-web-core';

import {
  Container,
  ContainerTitle,
  ContainerUrl,
  IconTitle,
  Title,
  QuestionIndex,
  WarnBoxMessage,
  TextLink,
} from './styles';

import ErrorMessage from '../error';

const Url = (props) => {
  const {
    index,
    errors,
    touched,
    question,
    onChangeUrl,
    taskIndex,
    testType,
  } = props;

  let label = '';

  if (testType === 'survey') {
    label = `${(taskIndex || taskIndex === 0) ? `surveysPages[${taskIndex}]` : ''}tasks.${index}.label`;
  } else {
    label = `tasks.${index}.label`;
  }

  const checkUrlWord = useMemo(() => {
    const words = ['figma', 'invis', 'adobe'];

    const hasFound = words.some((word) => question?.label.indexOf(word) !== -1);

    return hasFound;
  }, [question.label]);

  return (
    <Container>
      <ContainerTitle>
        <QuestionIndex>{index + 1}</QuestionIndex>
        <IconTitle src="/images/question-url.png" />
        <Title color="questionTitleUrl">
          URL
        </Title>
      </ContainerTitle>
      <ContainerUrl>
        <FastField
          name={label}
          minWidth="100%"
          placeholder="https://example.com"
        >
          {({
            field,
            form,
            meta,
          }) => {
            const newField = _.cloneDeep(field);
            newField.value = newField.value ? newField.value.trim() : '';
            newField.value = _.trimStart(newField.value);
            return (
              <InputFormField
                form={form}
                meta={meta}
                field={newField}
                onChangeUrl={onChangeUrl}
                onBlur={(event) => {
                  form.handleBlur(event);
                  const trimmedValue = _.trim(event.target.value);
                  form.setFieldValue(field.name, trimmedValue);
                }}
                placeholder="https://example.com"
              />
            );
          }}
        </FastField>

        <ErrorMessage
          index={index}
          errors={errors}
          touched={touched}
        />

        {checkUrlWord && (
          <WarnBoxMessage>
            Since you’re testing a prototype, please make sure the link is publicly accessible.
            <TextLink
              target="_blank"
              href="http://help.playbookux.com/en/articles/6093348-tips-for-enabling-share-settings"
            >
              &nbsp;Tips for enabling share settings
            </TextLink>
          </WarnBoxMessage>
        )}
      </ContainerUrl>
    </Container>
  );
};

Url.propTypes = {
  index: PropTypes.number.isRequired,
  errors: PropTypes.shape().isRequired,
  touched: PropTypes.shape().isRequired,
  question: PropTypes.shape(),
  onChangeUrl: PropTypes.func,
  taskIndex: PropTypes.number,
  testType: PropTypes.string.isRequired,
};

Url.defaultProps = {
  onChangeUrl: null,
  question: null,
  taskIndex: null,
};

export default Url;
